/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable prettier/prettier */
/* eslint-disable @next/next/no-img-element */
import _useTranslation from 'lib/hooks/_useTranslation'
import { Body1, Body2, ButtonText } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'
import BackgroundEclipse from 'assets/prevent-access/monetization/background-eclipse.svg'
import { useEffect, useMemo, useState } from 'react'
import Stack from 'components/elements/Stack'
import { legalPrivacyRoute, legalTOSRoute } from 'lib/constants/routes'
import { AdditionalSignUpAttributes, LoginSteps } from 'lib/tracking/attribution/signupattributes'
import { Know } from 'interfaces/Know'
import NewButton from 'components/elements/NewButton'
import AuthEmailStepByStep from 'components/feature/Authentication/AuthEmailStepByStep'
import AuthGoogle from 'components/feature/Authentication/AuthGoogle'
import { parseTranslationInterpolation } from 'lib/features/translation'
import { useToggleState } from 'lib/hooks/useToggleState'
import EmailIcon from 'assets/icons/mail.svg'
import { trackEvent } from 'lib/tracking/analytics-service'
import {
    AnalyticsEventPractisingElementAnswer,
    AnalyticsEventPractisingElementImpression,
} from 'lib/constants/AnalyticsEventType'
import { Flashcard } from 'interfaces/Flashcard'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import { useRouter } from 'next/router'
import { getCountryLanguageConfig } from 'lib/constants/countryLanguageConfig'
import { parseLocale } from 'lib/constants/localization'
import { appDeepLinkKnow } from 'lib/features/app-deep-links'
import { redirectToAppDownloadUrlAsync } from 'lib/features/app-links'

const Container = styled.div<{
    showEmailBannerFlow?: boolean
    isShownAsBanner?: boolean
    isQuestionShown?: boolean
    questionCount?: number
    wasLastQuestionShown?: boolean
    showSignUpBanner?: boolean
    isDarkTheme?: boolean
}>`
    background-color: ${({ isDarkTheme }) => (isDarkTheme ? theme.colors.darkThemePrimary : theme.colors.violet)};
    padding: 25px 50px 25px 50px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    transition: height 0.5s ease-in-out, opacity 0.5s ease-in-out;
    min-width: 1024px;

    ${({ isQuestionShown }) =>
        isQuestionShown
            ? css`
                  min-height: 525px;
              `
            : css`
                  min-height: 525px;
              `}

    @media (max-width: 1050px) {
        height: fit-content !important;
        min-width: 750px;
    }
    gap: 30px;
    width: 100%;
    position: relative;

    @media (max-width: 800px) {
        gap: 10px;
        padding: 25px;
        min-width: unset;
        width: 100%;
    }
    .steps {
        display: grid;
        grid-template-columns: ${({ questionCount }) => css`repeat(${questionCount}, 1fr)`};
        width: 100%;
        height: 10px;
        gap: 10px;
        position: relative;
        p {
            position: absolute;
            top: 10px;
        }
    }

    .close {
        position: absolute;
        top: 10px;
        right: 0px;
        z-index: 2;
        cursor: pointer;
    }
    ${({ isShownAsBanner }) =>
        isShownAsBanner
            ? css`
                  overflow: hidden;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
                  border-radius: ${theme.borderRadius.normal};
                  width: 650px;
                  padding: 10px 30px 25px 30px;
                  .close {
                      right: 7.5px;
                  }
              `
            : ''}

    .background {
        position: absolute;
        bottom: -125px;
        left: -150px;
        z-index: 0;
        @media (max-width: 1150px) {
            display: none;
        }
    }

    .question {
        width: 100%;
        border-radius: ${theme.borderRadius.normal};
        background-color: ${theme.colors.white};
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 25px 15px;
        z-index: 2;
        transition: all 0.3s ease-in-out;
        ${({ showSignUpBanner }) =>
            showSignUpBanner
                ? css`
                      filter: blur(10px);
                  `
                : ''}
    }

    .post-asnwers {
        width: 100%;
        gap: 20px;
        display: flex;
        justify-content: space-evenly;
        flex-direction: row;
        div {
            flex: 1;
            max-width: 320px;
        }
    }
    .answers {
        width: 100%;
        gap: 15px;
        display: grid;
        justify-content: center;
        grid-template-columns: 1fr 1fr;
        transition: all 0.3s ease-in-out;
        ${({ showSignUpBanner }) =>
            showSignUpBanner
                ? css`
                      filter: blur(10px);
                  `
                : ''}
        @media(max-width: 750px) {
            grid-template-columns: 1fr;
        }
    }
    .options-practise {
        display: grid;
        align-items: center;
        justify-content: center;
        height: 70px;
        gap: 35px;
        grid-template-columns: 400px 150px;

        svg {
            fill: ${theme.colors.body2Black};
        }
    }
    div {
        z-index: 2;
    }
    position: relative;
    .signup {
        transition: all 1s ease;
        position: absolute;
        top: 275px;
        width: 100%;
        left: 0;
        z-index: 20;

        animation: showContent 1s 1 ease-in-out;
        @keyframes showContent {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    span {
        transition: all 1.5s ease;
        animation: showEmailButton 1.5s 1 ease-in-out forwards;
        @keyframes showEmailButton {
            0% {
                opacity: 0;
            }
            50% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    ${({ showEmailBannerFlow }) =>
        showEmailBannerFlow
            ? css`
                  .email-banner {
                      padding-top: 5px;
                      padding-bottom: 9px;
                      input {
                          border-radius: ${theme.borderRadius.small} !important;
                          border: none !important;
                          position: relative;
                          bottom: 1px;
                      }
                      button {
                          div {
                              height: 45px;
                              width: 100%;
                          }
                      }
                  }
                  .inputs {
                      * {
                          color: ${theme.colors.white};
                      }
                      gap: 15px;
                      display: grid;
                      grid-template-columns: 1fr 1fr;
                  }
              `
            : ''};
`

const LegalArticleLink = styled.a`
    && {
        font-size: 12px !important;
        font-weight: 600;
        color: ${theme.colors.subtitleBlack};
        cursor: pointer;
        font-family: var(--font-inter);
    }
`

const Card = styled.div<{ isCorrect?: boolean; isWrong?: boolean; isQuestionShown?: boolean }>`
    width: 100%;
    border-radius: ${theme.borderRadius.normal};
    background-color: ${theme.colors.white};
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 10px;
    z-index: 2;

    position: relative;
    border: 2px solid ${theme.colors.violet};
    transition: border 0.2s ease-in-out, opacity 0.2s ease-in-out;

    ${({ isQuestionShown }) =>
        isQuestionShown
            ? css`
                  cursor: pointer;
                  :hover {
                      border: 2px solid ${theme.colors.deepSeaBlue}66;
                  }
              `
            : ''}
    .count {
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 12px 0 ${theme.borderRadius.normal} 0;
        width: 35px;
        height: 25px;
        border: 1px solid ${theme.colors.contentBody}22;
        background-color: ${theme.colors.violetDarkerBackground};
    }
    ${({ isCorrect }) =>
        isCorrect
            ? css`
                  cursor: auto;
                  border: 2px solid #47d877;
                  :hover {
                      background-color: ${theme.colors.white};
                  }
              `
            : ''}
    ${({ isWrong }) =>
        isWrong
            ? css`
                  cursor: auto;
                  border: 2px solid #fc7974;
                  :hover {
                      background-color: ${theme.colors.white};
                  }
              `
            : ''}
`

const Step = styled.span<{ status?: 0 | 1 | null; isActive?: boolean }>`
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background-color: ${({ status }) =>
        status === null ? `${theme.colors.contentBody}33` : status === 1 ? '#47d877' : '#fc7974'};

    ${({ isActive }) =>
        isActive
            ? css`
                  background-color: ${theme.colors.deepSeaBlue};
              `
            : ''}
`

enum PractisingElementStatus {
    Question = 'QUESTION',
    CorrectAnswer = 'CORRENT_ANSWER',
    WrongAnswer = 'WRONG_ANSWER',
    Closed = 'CLOSED',
}

interface Props {
    additionalSignUpAttributes?: AdditionalSignUpAttributes
    onSuccessSignup: (isNewAccount: boolean, type: 'google' | 'apple' | 'email') => void
    onEmailButtonClick: () => void
    know?: Know
    isShownAsBanner?: boolean
    flashcards: Flashcard[]
    isDarkTheme?: boolean
}

const PractisingElementBody = ({
    know,
    additionalSignUpAttributes,
    onEmailButtonClick,
    onSuccessSignup,
    isShownAsBanner,
    flashcards,
    isDarkTheme,
}: Props) => {
    const [showEmailBannerFlowElement, toggleEmailBannerFlowElement] = useToggleState(false)
    const [progressStatus, setProgressStatus] = useState<PractisingElementStatus>(PractisingElementStatus.Question)
    const [selectedWrongAnswer, setSelectedWrongAnswer] = useState('')
    const [questionIndex, setQuestionIndex] = useState(0)
    const [showSignUpBanner, setShowSignUpBanner] = useState(false)
    const initialAnswerStats = (new Array(flashcards.length)?.fill(null) as [x: null]) ?? [null]
    const [answerStats, setAnswerStats] = useState<(0 | 1 | null)[]>(initialAnswerStats)
    const { t } = _useTranslation('knows')
    const { t: tCommon } = _useTranslation('common')
    const lg = useMedia(deviceSize.lg)
    const { locale } = useRouter()
    const parsedLocale = parseLocale(locale)
    const countryLanguageConfig = getCountryLanguageConfig(parsedLocale.contentLanguageCode)

    const isLaunched = countryLanguageConfig?.isLaunched
    const isQuestionShown = progressStatus === PractisingElementStatus.Question
    const didUserAsnwerCorretly = progressStatus === PractisingElementStatus.CorrectAnswer
    const wasQuestionClosed = progressStatus === PractisingElementStatus.Closed

    const onContentClick = () => {
        const downloadDeepLinkPath = know ? appDeepLinkKnow(know.uuid) : undefined
        redirectToAppDownloadUrlAsync('dynamic', 'know-mobile-blurred-preview-button', downloadDeepLinkPath)
    }

    useEffect(() => {
        if (!know) return

        trackEvent(AnalyticsEventPractisingElementImpression, { know })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [know])

    const onAnswerClicked = (isCorrect: boolean, questionNumber: number) => {
        if (!isQuestionShown) return
        trackEvent(AnalyticsEventPractisingElementAnswer, {
            know,
            value: isCorrect ? 'correct' : 'wrong',
            valueId: questionNumber,
        })
        setProgressStatus(isCorrect ? PractisingElementStatus.CorrectAnswer : PractisingElementStatus.WrongAnswer)
        setAnswerStats((prev) => {
            if (prev.length < questionIndex) return prev
            const temp = [...prev]
            temp[questionIndex] = isCorrect ? 1 : 0
            return temp
        })

        if (questionIndex === flashcards.length - 1) {
            setTimeout(() => {
                setShowSignUpBanner(true)
            }, 1500)
        }
    }

    const loadNextQuestion = () => {
        setQuestionIndex((index) => ++index)
        setProgressStatus(PractisingElementStatus.Question)
    }

    const selectedQuestion = flashcards[questionIndex]
    const wasLastQuestionShown = questionIndex === flashcards.length - 1

    const answers = useMemo(
        () =>
            selectedQuestion?.incorrectAnswers && selectedQuestion.answerText
                ? [
                      { isCorrect: true, answer: selectedQuestion.answerText },
                      ...selectedQuestion.incorrectAnswers.map((answer) => ({ isCorrect: false, answer })),
                  ].sort(() => Math.random() - 0.5)
                : [],
        [selectedQuestion]
    )

    return (
        <Container
            isShownAsBanner={isShownAsBanner}
            showEmailBannerFlow={showEmailBannerFlowElement}
            wasLastQuestionShown={wasLastQuestionShown}
            isQuestionShown={isQuestionShown}
            questionCount={flashcards.length}
            showSignUpBanner={showSignUpBanner}
            isDarkTheme={isDarkTheme}
        >
            <Stack gutter={20}>
                <div className="steps">
                    {answerStats.map((answer, i) => (
                        <Step status={answer} key={`answer-${i}`} isActive={i === questionIndex && answer === null} />
                    ))}
                </div>
                <Stack gutter={10}>
                    {isQuestionShown ? (
                        <>
                            <Body1
                                color={isDarkTheme ? theme.colors.white : theme.colors.contentBody}
                                fontFamily="var(--font-inter)"
                                fontSize={30}
                                fontWeight={600}
                                textAlign="center"
                            >
                                {t('knows/practisingElementsTitle')}
                            </Body1>
                        </>
                    ) : (
                        <>
                            <Body1
                                color={isDarkTheme ? theme.colors.white : theme.colors.contentBody}
                                fontFamily="var(--font-inter)"
                                fontSize={30}
                                fontWeight={600}
                                textAlign="center"
                            >
                                {didUserAsnwerCorretly
                                    ? t('knows/practisingElementsCorrectAnswerLabel')
                                    : wasQuestionClosed
                                    ? t('knows/practisingElementsAnswerLabel')
                                    : t('knows/practisingElementsWrongAnswerLabel')}
                            </Body1>

                            {wasLastQuestionShown ? (
                                <Body1
                                    color={isDarkTheme ? theme.colors.white : theme.colors.contentBody}
                                    fontFamily="var(--font-inter)"
                                    fontSize={20}
                                    fontWeight={600}
                                    textAlign="center"
                                >
                                    {didUserAsnwerCorretly
                                        ? t('knows/practisingElementsCorrectAnswerSufix')
                                        : wasQuestionClosed
                                        ? ''
                                        : t('knows/practisingElementsWrongAnswerSufix')}{' '}
                                    {t('knows/practisingElementsSignupCTA')}
                                </Body1>
                            ) : null}
                        </>
                    )}
                </Stack>
                <Stack gutter={20}>
                    <div className="question">
                        <Body1 fontFamily="var(--font-inter)" fontWeight={500} textAlign="center">
                            {selectedQuestion?.questionText}
                        </Body1>
                    </div>
                    <div className="answers">
                        {answers.map(({ answer, isCorrect }, i) => (
                            <Card
                                key={answer}
                                onClick={() => {
                                    if (!isQuestionShown) return
                                    onAnswerClicked(isCorrect, i)
                                    setSelectedWrongAnswer(isCorrect ? '' : answer)
                                }}
                                isQuestionShown={isQuestionShown}
                                isWrong={answer === selectedWrongAnswer}
                                isCorrect={isCorrect && !isQuestionShown}
                            >
                                <div className="count">
                                    <Body2
                                        textAlign="center"
                                        color={theme.colors.headlineDark}
                                        fontFamily="var(--font-open-sans)"
                                        fontWeight={600}
                                    >
                                        {['A', 'B', 'C', 'D'][i]}
                                    </Body2>
                                </div>
                                <Body1 fontFamily="var(--font-inter)" fontWeight={500} textAlign="center" fontSize={14}>
                                    {answer}
                                </Body1>
                            </Card>
                        ))}
                    </div>
                </Stack>
            </Stack>
            {!isQuestionShown && !wasLastQuestionShown ? (
                <NewButton
                    onClick={loadNextQuestion}
                    color={theme.colors.deepSeaBlue}
                    width={300}
                    fullWidth
                    height={50}
                    borderRadius={theme.borderRadius.card}
                >
                    <Body2 fontWeight={500} fontFamily="var(--font-inter)" color={theme.colors.white}>
                        {t('knows/practisingElementsNextQuestionButtonLabel')}
                    </Body2>
                </NewButton>
            ) : null}
            {!isQuestionShown && wasLastQuestionShown && showSignUpBanner ? (
                <div className="signup">
                    {!lg ? (
                        <Stack gutter={0}>
                            {showEmailBannerFlowElement ? (
                                <div className="email-banner">
                                    {additionalSignUpAttributes ? (
                                        <AuthEmailStepByStep
                                            type={LoginSteps.SignUpEmail}
                                            additionalSignUpAttributes={additionalSignUpAttributes}
                                            onClick={() => {}}
                                            onSuccess={(isNewAccount) => onSuccessSignup(isNewAccount, 'email')}
                                            removeMargins
                                            isSmall
                                            buttonText={tCommon('common/createFreeAccount')}
                                        />
                                    ) : null}
                                    <span />
                                </div>
                            ) : (
                                <div className="options-practise">
                                    {additionalSignUpAttributes ? (
                                        <AuthGoogle
                                            type={LoginSteps.SignUp}
                                            additionalSignUpAttributes={additionalSignUpAttributes}
                                            onClick={() => {}}
                                            onSuccess={(isNewAccount) => onSuccessSignup(isNewAccount, 'google')}
                                            handleNoAccount={() => {}}
                                        />
                                    ) : null}
                                    <span onClick={onEmailButtonClick}>
                                        <NewButton
                                            onClick={toggleEmailBannerFlowElement}
                                            icon={<EmailIcon />}
                                            color={`${theme.colors.contentBody}33`}
                                            type="secondary"
                                            height={40}
                                            fullWidth
                                            borderRadius={theme.borderRadius.small}
                                        >
                                            <Body2 fontWeight={500} fontFamily="var(--font-inter)">
                                                Email
                                            </Body2>
                                        </NewButton>
                                    </span>
                                </div>
                            )}
                            <Stack>
                                <Body2
                                    textAlign="center"
                                    color={theme.colors.subtitleBlack}
                                    fontFamily="var(--font-open-sans)"
                                    fontWeight={500}
                                    fontSize={12}
                                >
                                    {parseTranslationInterpolation(t('knows/signUpRegisterLegalMessage'), [
                                        { index: 1, component: LegalArticleLink, props: { href: legalTOSRoute } },
                                        {
                                            index: 3,
                                            component: LegalArticleLink,
                                            props: { href: legalPrivacyRoute },
                                        },
                                    ])}
                                </Body2>
                                {showEmailBannerFlowElement ? (
                                    <Body2
                                        textAlign="center"
                                        color={theme.colors.subtitleBlack}
                                        fontFamily="var(--font-inter)"
                                        fontWeight={400}
                                        fontSize={12}
                                        style={{ cursor: 'pointer' }}
                                        onClick={toggleEmailBannerFlowElement}
                                    >
                                        {tCommon('common/signUpWithGoogleButton')}
                                    </Body2>
                                ) : null}
                            </Stack>
                        </Stack>
                    ) : (
                        <>
                            {isLaunched ? (
                                <NewButton
                                    height={60}
                                    width={250}
                                    borderRadius={theme.borderRadius.normal}
                                    color={theme.colors.deepSeaBlue}
                                    onClick={onContentClick}
                                >
                                    <ButtonText color={theme.colors.white}>
                                        {tCommon('common/conversionCTAButton')}
                                    </ButtonText>
                                </NewButton>
                            ) : null}
                        </>
                    )}
                </div>
            ) : null}
            <BackgroundEclipse className="background" />
        </Container>
    )
}

export default PractisingElementBody
